import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/wondercoms-logo-green.png";

export default function Footer() {
  return (
    <footer className="wc-footer">
      <div className="wc-container wc-footer-top">
        <div><Link to="/" className="wc-logo" aria-label="WonderComs ホーム"><img src={logo} alt="WonderComs" /></Link><p>株式会社ワンダーコムズ</p><p>システムの設計・開発・運用支援</p></div>
        <nav aria-label="サービス案内"><p>サービス</p><Link to="/shikumi-seibi">つくったあと</Link><Link to="/dx">業務システム・クラウド開発</Link><Link to="/apps-sdk">ChatGPTアプリ連携</Link></nav>
        <nav aria-label="企業情報"><p>企業情報</p><Link to="/company">会社概要</Link><Link to="/news">お知らせ</Link><Link to="/contact">お問い合わせ</Link></nav>
      </div>
      <div className="wc-container wc-footer-bottom"><small>© {new Date().getFullYear()} WonderComs Inc.</small><span>DEVELOPMENT & OPERATIONS</span></div>
    </footer>
  );
}
